import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Instituicao } from 'src/app/models/instituicao';
import { LivroRegistro } from 'src/app/models/livro-registro';
import { DiplomaDigital } from 'src/app/models/diploma-digital';

@Injectable({
  providedIn: 'root'
})

export class BuscaService {

  baseURL = environment.url;
  headers = new HttpHeaders({
    'apikey': environment.apptoken
  });

  // DEBUG - PRD
  //baseURL = 'https://prd-system-yduqs-alunos.br-s1.cloudhub.io/api';
  //headers = new HttpHeaders({
  //  client_id: '62e5d535df544e73b7284cd218c97be5',
  //  client_secret: 'c4d2F44d94AB423789AEf94b7B8524b9'
  //});

  constructor(
    private http: HttpClient
  ) { }

  // Lista de instituições por marca
  getInstituicao(codigo: number) {
    return this.http.get<Instituicao>(`${this.baseURL}/instituicao-ensino`, {
      headers: this.headers,
      params: {
        codGrupoMarca: codigo
      }
    });
  }

  // Lista as informações do registro pesquisado
  getResultado(dados: any, pageSize: number, pageNumber: number) {
    return this.http.post<LivroRegistro>(`${this.baseURL}/livro-registro-diploma`, dados, {
      headers: this.headers,
      params: {
        page_size: pageSize,
        page_number: pageNumber
      }
    });
  }

  // Informações do diploma
  getDiplomaDigital(codigo: string) {
    return this.http.get<[DiplomaDigital]>(`${this.baseURL}/diploma-digital`, {
      headers: this.headers,
      params: {
        codValidacaoDiploma: codigo
      }
    });
  }

}
